import { useMortgageDetailsDownpaymentFieldBindings } from "@Client/@Composables/application-standalone/pages/mortgage-details/useMortgageDetailsDownpaymentFieldBindings";
import { useMortgageDetailsFieldBindings } from "@Client/@Composables/application-standalone/pages/mortgage-details/useMortgageDetailsFieldBindings";
import { useMortgageDetailsFieldVisibility } from "@Client/@Composables/application-standalone/pages/mortgage-details/useMortgageDetailsFieldVisibility";
import { useSubjectPropertyFieldBindings } from "@Client/@Composables/application-standalone/pages/subject-property/useSubjectPropertyFieldBindings";
import { useSubjectPropertyFieldVisibility } from "@Client/@Composables/application-standalone/pages/subject-property/useSubjectPropertyFieldVisibility";
export const goalsBindingsAndVisibilities = downpaymentIndex => {
  const {
    propertyDetailsPurchasePrice,
    propertyDetailsOccupancy,
    propertyAddress,
    propertyDetailsAddressProvince
  } = useSubjectPropertyFieldBindings();
  const {
    propertyDetailsPurchasePriceVisible,
    propertyDetailsOccupancyVisible,
    propertyAddressVisible,
    propertyAddressProvinceVisible
  } = useSubjectPropertyFieldVisibility();
  const {
    mortgageDetailsClosingDateVisible,
    mortgageDetailsDownpaymentAmountVisible
  } = useMortgageDetailsFieldVisibility();
  const {
    mortgageDetailsDownpaymentAmount
  } = useMortgageDetailsDownpaymentFieldBindings({
    downpaymentIndex
  });
  const {
    mortgageDetailsClosingDate
  } = useMortgageDetailsFieldBindings();
  return {
    bindings: {
      propertyDetailsPurchasePrice,
      propertyDetailsOccupancy,
      propertyAddress,
      propertyDetailsAddressProvince,
      mortgageDetailsDownpaymentAmount,
      mortgageDetailsClosingDate
    },
    visibilities: {
      propertyDetailsPurchasePriceVisible,
      propertyDetailsOccupancyVisible,
      propertyAddressVisible,
      propertyAddressProvinceVisible,
      mortgageDetailsClosingDateVisible,
      mortgageDetailsDownpaymentAmountVisible
    }
  };
};